{
  "1": {
    "team": "Team",
    "transportProvider": "Transport provider",
    "tracking": "Tracking",
    "provider": "Provider",
    "linkCode": "Link code",
    "referenceId": "Reference ID",
    "reference": "Reference",
    "chainOfCustody": "Chain Of Custody",
    "statusUpdates": "Status updates"
  },
  "2": {
    "team": "Client",
    "transportProvider": "Carrier",
    "tracking": "Carrier",
    "provider": "Carrier",
    "linkCode": "PPS Number",
    "referenceId": "Customer PO",
    "reference": "Customer PO",
    "chainOfCustody": "Transit History",
    "statusUpdates": "Transit history"
  },
  "15": {
    "referenceId": "Order #",
    "team": "Team",
    "transportProvider": "Transport provider",
    "tracking": "Tracking",
    "provider": "Provider",
    "reference": "Order",
    "linkCode": "Link Code",
    "chainOfCustody": "Chain Of Custody",
    "statusUpdates": "Status updates"
  },
  "16": {
    "team": "Team",
    "transportProvider": "Transport provider",
    "tracking": "Tracking",
    "provider": "Provider",
    "linkCode": "Link code",
    "referenceId": "Job Number",
    "reference": "Job number",
    "chainOfCustody": "Chain Of Custody",
    "statusUpdates": "Status updates"
  }
}
